// extracted by mini-css-extract-plugin
export default {"root":"Registration_root__b6AIL","wrapper":"Registration_wrapper__m1GMr","wrapper_img":"Registration_wrapper_img__D+rEm","main__wrapper":"Registration_main__wrapper__rMkM+"};